import React from "react";
import { connect } from "react-redux";
import { closePortfolioDeleteModal, deletePortfolio } from "actions/portfolio";
import PropTypes from "prop-types";
import { portfolioShape } from "shapes";

import CancelButton from "components/CancelButton";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "components/Modal";
import SubmitButton from "components/SubmitButton";
import TitledDropdown from "components/TitledDropdown";
import { Translate } from "utils";

const { t } = new Translate("PortfolioDeleteModal");

export class PortfolioDeleteModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      transferPortfolio: {},
    };
    this.handlePortfolioSelect = this.handlePortfolioSelect.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    this.props.onClose();
    this.setState({ transferPortfolio: {} });
  }

  handleDelete() {
    const { transferPortfolio } = this.state;
    const { onDelete, portfolio } = this.props;

    if (
      // eslint-disable-next-line
      confirm(
        t(`confirm${transferPortfolio.id ? "Transfer" : "Delete"}`, {
          portfolio: portfolio.name,
          transferPortfolio: transferPortfolio.name,
        })
      )
    ) {
      onDelete(portfolio.id, transferPortfolio.id);
      this.setState({ transferPortfolio: {} });
    }
  }

  handlePortfolioSelect(transferPortfolio) {
    this.setState({ transferPortfolio });
  }

  render() {
    const { isLoading, isOpen, portfolios } = this.props;
    const { transferPortfolio } = this.state;
    if (!isOpen) return null;

    return (
      <Modal onClose={this.handleCancel} width={320} isOpen>
        <ModalHeader onClose={this.handleCancel}>{t("header")}</ModalHeader>
        <ModalBody>
          <span dangerouslySetInnerHTML={{ __html: t("warning") }} />
        </ModalBody>
        <ModalBody>
          <TitledDropdown
            emptyText={t("noPortfolios")}
            onSelect={this.handlePortfolioSelect}
            selectedValue={transferPortfolio}
            title={t("transfer")}
            valueExtractor={(p) => p.name}
            values={portfolios}
            isEdit
            isUnselectable
          />
        </ModalBody>
        <ModalFooter>
          <CancelButton onClick={this.handleCancel} />
          <SubmitButton
            isSubmitting={isLoading}
            onSubmit={this.handleDelete}
            submitLabel={t("delete")}
            submittingLabel={t("deleting")}
            isDanger
          />
        </ModalFooter>
      </Modal>
    );
  }
}

PortfolioDeleteModal.propTypes = {
  portfolio: PropTypes.shape(portfolioShape),
  portfolios: PropTypes.arrayOf(PropTypes.shape(portfolioShape).isRequired).isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
};

const mapStateToProps = ({ isPortfolioDeleteModalOpen, loading, portfolios }) => {
  const portfolio = portfolios.find((p) => p.isEdit) || { company: {} };

  return {
    portfolio,
    portfolios: portfolios.filter(
      (p) => p.id !== portfolio.id && p.company.id === portfolio.company.id && !p.fake
    ),
    isLoading: loading.portfolio,
    isOpen: isPortfolioDeleteModalOpen,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closePortfolioDeleteModal()),
  onDelete: (portfolioID, transferPortfolioID) =>
    dispatch(deletePortfolio(portfolioID, transferPortfolioID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioDeleteModal);
